import { 
  Fragment, 
  useEffect, 
  useRef, 
  useState 
} from 'react';

import DataGrid, {
    Column,
    ColumnChooser,
    Export,
    FilterRow,
    HeaderFilter,
    Pager,
    Paging,
    Scrolling,
    Selection,
  } from 'devextreme-react/data-grid';
import { Button } from 'devextreme-react';
import { Bounce, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { persianLanguage } from '../../../../constants/persianTerms';
import { BASE_API, WS_BASE_API } from '../../../../constants/api';
import axiosHttp from '../../../interceptors/axios-interceptor';
import TransactionRemaininDeadline from '../../transaction-remaining-deadline/transaction-remaining-deadline';
import { onExporting } from '../../../../shared/excel-export';
import { persianDigitPrice, persianPrice } from '../../../../shared/persian-number';
import { errorNotify, successNotify } from '../../../../shared/notifications';
import { useAuth } from '../../../auth/auth-provider/auth-provider';
import { datagridCustomStore } from '../../../../shared/devexpress';
import { DATAGRID_ALLOWED_FILTER_OPERATIONS, DATAGRID_ALLOWED_PAGE_SIZES, DG_FILTER_EQUALS_TO_OPERATION, DG_HEADER_FILTER_QD_UNIT_DATA_SOURCE, DG_HEADER_FILTER_TRANSACTION_ORDER_TYPE_DATA_SOURCE, DG_HEADER_FILTER_TRANSACTION_TYPE_DATA_SOURCE } from '../../../../constants/constant-arrays';
import { DEFAULT_DATAGRID_PAGE_SIZE } from '../../../../constants/constant-numbers';
import { locale, loadMessages } from 'devextreme/localization';

import faMessages from 'devextreme/localization/messages/fa.json';
import GetTransactionFieldVisibility from '../../../api-layer/transaction-field-visibility-api/GetTransactionFieldVisibility';
import { saveTransactionFieldVisibilityChange } from '../transactionUtils';
import { useQuantityDefinition } from '../../../custom-providers/quantity-definition-provider/quantity-definition-provider';
import { convertPersianOrArabicNumbersToEnglishInTheString } from '../../../../shared/numbers';
import TransactionExpirationDuration from '../../../transaction-expiration-duration/transaction-expiration-duration';
import SendTransactionToSource from '../../../api-layer/transaction-api/SendTransactionToSource';
import { consoleLog } from '../../../../shared/utils';

loadMessages(faMessages);
locale('fa');

export default function TransactionAwaitingList(){
  const auth = useAuth();
  const {quantityDefinitions} = useQuantityDefinition();

  const filterOperations=['contains'];

  const transactionApiUrl = `${BASE_API}transactions/`;
  const [transactions, setTransactions] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [transactionChanged, setTransactionChanged] = useState(0)
  const [isDisabled, setIsDisabled] = useState(false);
  const [transactionFieldVisibility, setTransactionFieldVisibility] = useState(null);
  const [qds, setQDS] = useState(null);

  const dataGridRef = useRef(null);

    useEffect(()=>{
        getTransactions();
        getTransactionFieldVisibility()
    }, [
      transactionApiUrl, 
      transactionChanged,
    ]);
      
  const getTransactionFieldVisibility = () => {
    GetTransactionFieldVisibility(auth.user.id).then(
      response => {
        setTransactionFieldVisibility(response.data);
      }
    ).catch(
      error => {
        setTransactionFieldVisibility(null);
      }
    );
  }
    const getTransactions = () => 
    {
      const api = `${transactionApiUrl}devextreme/awaiting/`;
      let res = datagridCustomStore('id', api);
      setTransactions(res);
    };

    useEffect(() => {
        const interval = setInterval(() => {
          getTransactions();
        }, 10000);    
        return () => clearInterval(interval);
      }, []);

    useEffect(() => {
      if(!auth?.user?.isAdmin){
        return;
      }
      const ws = new WebSocket(
          `${WS_BASE_API}transactions/?token=${auth.token}`,

          );
      ws.onopen = (event) => {
        console.log('open : ', event)
      };
      ws.onmessage = function (event) {
        const data = JSON.parse(event.data);
        getTransactions();
      };
      ws.onclose = function(event){};
      return () =>{
          if (ws.readyState === 1) { 
              ws.close();
          }}
    }, [auth.token]);
    
      const onSelectionChanged = (selectedRowData) => 
      {
          setSelectedRowKeys(selectedRowData.selectedRowKeys);
      };

    const approvationChanged = (value) => {
      setTransactionChanged(value)
    }

    const cellRender = (e) => {
      if(e){
        return <TransactionRemaininDeadline 
                  expiration={e?.data.expiration} 
                  transactionId={e?.data.id} 
                  approvationChanged={approvationChanged}
                  isApproved={e.data.isApproved}/>
      } else {
        return ''
      }

  };

  const persianAmount = (data) => {
    return persianPrice(data.amount);
  };

  const persianUserMarkupValue = (data) => {
    return persianPrice(data.userMarkupValue);
  };

  const persianSourceMarkupValue = (data) => {
    return persianPrice(data.sourceMarkupValue);
  };

  const persianUnitPrice = (data) => {
    return persianPrice(data.unitPrice);
  };

  const persianTotalPrice = (data) => {
    return persianDigitPrice(data.totalPrice);
  };

  const onRowPreparedEffect = (e) => {
    if(e.data){
      if(e.data.isApproved === 400 || e.data.isApproved === 440){
        e.rowElement.classList.add("bg-red-100");
      } else if(e.data.isApproved === 2){
        e.rowElement.classList.add("bg-green-100");
      }
    }
  }


  const isApprovedChange = (transactionId, changeType) => {
    setIsDisabled(true);
    let formData = { 'isApproved': null}

    if(changeType === 'reject'){
      formData = { 'isApproved': 400}
    }
    else if(changeType === 'reject-by-price-change'){
      formData = { 'isApproved': 450}
    } 
    else if(changeType === 'reject-because-no-credit'){
      formData = { 'isApproved': 460}
    } 
    else if(changeType === 'approve'){
      formData = { 'isApproved': 2}
    }
      const api = `${BASE_API}transactions/change-approve/${transactionId}/initial/`;
      axiosHttp.put(api, formData).then(
          response => {
              const message = `وضعیت معامله با شناسه
              ${transactionId}
              با موفقیت تغییر کرد
              `
              successNotify(message);
              getTransactions();
              setIsDisabled(false);
          }
      ).catch(
        error => {
          setIsDisabled(false);
          if(error?.response?.status ===  403){
            const message = `امکان تغییر وصعیت معامله با شناسه
            ${transactionId}
            وجود ندارد
            `
          errorNotify(message);
          }
        }
      );
  }

  const sendToExternal = (code) => {
    SendTransactionToSource(code).then(
      response => {
        successNotify(persianLanguage.phrase.success.SUCCESS_200);
        getTransactions();
      }
    ).catch(
      error => {
        consoleLog({'error in record new gold data source': error});
        if(error.status === 400){
            errorNotify(persianLanguage.phrase.error.ERROR_400);
        }
        else if(error.status === 404){
            errorNotify(persianLanguage.phrase.error.ERROR_404);
        }
        else if(error.status === 401){
            errorNotify(persianLanguage.phrase.error.ERROR_401_2);
        }
        else if(error.status === 403){
            errorNotify(persianLanguage.phrase.error.ERROR_403);
        }
      }
    );
  }
  
  const renderIsApprovedTitleCell = (e) => {
    if (e.data && e.data.isApproved === 1 && auth?.user && auth?.user.isAdmin && e.data.externalApproving === false){
      return <>
        <Button 
          className='m-1' 
          disabled={isDisabled} 
          type="success" 
          stylingMode='outlined'
          icon="check" onClick={() => isApprovedChange(e.data.id, 'approve')}>
            <div>
              {persianLanguage.word.general.APPROVE}
            </div>
          </Button>
        <Button 
          className='m-1' 
          disabled={isDisabled} 
          type="danger" 
          stylingMode='outlined'
          icon="remove" onClick={() => isApprovedChange(e.data.id, 'reject-by-price-change')}>
          <div>
              {persianLanguage.phrase.gold.CHANGE_MESQAL}
          </div>
        </Button>
        <Button 
          className='m-1' 
          disabled={isDisabled} 
          type="danger" 
          stylingMode='outlined'
          icon="remove" onClick={() => isApprovedChange(e.data.id, 'reject-because-no-credit')}>
          <div>
              {persianLanguage.phrase.credit.NO_CREDIT}
          </div>
        </Button>
        </>      

    }
    else if(e.data && e.data.isApproved === 1 && auth?.user && auth?.user.isAdmin 
      && e.data.externalApproving === true && e.data.autoSend === false
      && e.data.sentToSource === false
    ){
      return <>
        <Button 
          className='m-1' 
          disabled={isDisabled} 
          type="default" 
          stylingMode='outlined'
          icon="check" onClick={() => sendToExternal(e.data.code)}>
            <div>
              {persianLanguage.word.general.SEND}
            </div>
          </Button>
        </>      
    }
    else {
      return e.data.isApprovedTitle
    }
  }

  const saveVisibilityChange = (dataField, newValue, previousValue) => {
    const userId = auth.user.id;
    saveTransactionFieldVisibilityChange(dataField, newValue, previousValue, userId).then(
      response => {
        successNotify(persianLanguage.phrase.success.SUCCESS_200);
      }
    ).catch(
      error => {
        errorNotify(persianLanguage.phrase.error.ERROR_400);
      }
    );
  }

  const handleOptionChanged = (e) => {
    if (e.name === 'columns' && dataGridRef.current) {
      const currentColumns = e.component.option('columns');
      
      const newValue = e.value;
      const previousValue = e.previousValue;
      const columnIndex = Number(e.fullName.split('[')[1].split(']')[0]);

      const theObject = currentColumns[columnIndex]
      const dataField = theObject['dataField']; 
      saveVisibilityChange(dataField, newValue, previousValue);
     }
  };

  const fillQDS = () => {
      // Extract id and name into new array
      if(quantityDefinitions && quantityDefinitions.length > 0){
        const extractedQDS = quantityDefinitions.map(item => (
          {
            text: item.title,
            value: convertPersianOrArabicNumbersToEnglishInTheString(item.title),
        }));
        setQDS(extractedQDS);
      }  
  }

  useEffect(()=> {
    fillQDS();
  },[
    quantityDefinitions?.length,
  ])

  const indexCell = (props) => {
    return <div>{persianDigitPrice(props.rowIndex + 1)}</div>;
  };

    return (
        <Fragment>
          <ToastContainer
          rtl={true}
          position="bottom-right"
          theme="dark"
          draggable
          transition={Bounce} 
          />


            <div className="user-select-none bg-primary-main border border-2 border-primary-fourth-30p box-shadow-0-4-4-0 mx-[28px]">
             <div className="border border-b-2 box-shadow-0-4-4-0 px-[26px] py-[14px] pb-5">
                  {`${persianLanguage.word.transaction.TRANSACTIONS_AWAITING}`}
              </div>
            
            <DataGrid
              id="grid-container"
              keyExpr="id"
              hoverStateEnabled={false}
              className='mt-[50px] mx-5 user-select-none custom-datagrid-bg'
              dataSource={transactions}
              allowColumnReordering={true}
              showBorders={true}
              rtlEnabled={true}
              showRowLines={true}
              focusedRowEnabled={true}
              onSelectionChanged={onSelectionChanged}
              ref={dataGridRef}
              onRowPrepared={onRowPreparedEffect}
              selectedRowKeys={selectedRowKeys}
              remoteOperations={true}
              allowColumnResizing={true}
              columnHidingEnabled={true}
              onExporting={onExporting}
              onOptionChanged={handleOptionChanged}
            >
              <Export enabled={true} allowExportSelectedData={false} />
              <Scrolling columnRenderingMode="virtual" />
              <Selection mode="single"/>
              <FilterRow visible={true} />
              <HeaderFilter visible={true} />
              <Pager
                showPageSizeSelector={true}
                showNavigationButtons={true}
                showInfo={true}
                infoText={'صفحه {0} از {1} ({2} مورد) '}
                rtlEnabled={true}
                displayMode={'compact'}
                visible={"totalCount > 0"}
                allowedPageSizes={DATAGRID_ALLOWED_PAGE_SIZES}
              />
              <Paging 
                rtlEnabled={true}
                defaultPageSize={DEFAULT_DATAGRID_PAGE_SIZE}
              />

              <ColumnChooser 
                enabled={true}
                mode='select'
              />
              <Column
                visible={true}
                allowFiltering={false}
                dataField="rowIndex"
                caption={persianLanguage.word.general.INDEX}
                cellRender={indexCell}
              />
              <Column
                visible={transactionFieldVisibility?.codeVisibility}
                dataField="code"
                dataType="number"
                filterOperations={filterOperations}
                allowHeaderFiltering={false}
                allowFiltering={true}
                caption={persianLanguage.word.general.TRACKING_CODE}
              />
              <Column
                visible={transactionFieldVisibility?.createdOnVisibility}
                dataField="createdOn"
                allowFiltering={false}
                allowHeaderFiltering={false}
                filterOperations={filterOperations}
                dataType="string"
                caption={persianLanguage.phrase.general.CREATED_ON}
              />
              <Column
                dataField="transactionDate"
                dataType="string"
                allowFiltering={false}
                allowHeaderFiltering={false}
                visible={transactionFieldVisibility?.transactionDateVisibility}
                caption={persianLanguage.word.transaction.TRANSACTION_DATE}
              /> 
              <Column
                dataField="transactionWeekDay"
                dataType="string"
                allowFiltering={false}
                allowHeaderFiltering={false}
                visible={transactionFieldVisibility?.transactionWeekdayVisibility}
                caption={persianLanguage.word.general.WEEKDAY}
              /> 
              <Column
                dataField="transactionTime"
                dataType="string"
                visible={transactionFieldVisibility?.transactionTimeVisibility}
                allowFiltering={false}
                allowHeaderFiltering={false}
                filterOperations={filterOperations}
                caption={persianLanguage.word.transaction.TRANSATION_TIME}
                />
              <Column
                width={80}
                dataField="transactionTypeLabel"
                dataType="string"
                allowFiltering={true}
                allowHeaderFiltering={false}
                headerFilter={{
                    allowSearch: false, // adds a search box in the filter menu
                    dataSource: DG_HEADER_FILTER_TRANSACTION_TYPE_DATA_SOURCE,
                }}
                filterOperations={filterOperations}
                visible={transactionFieldVisibility?.transactionTypeLabelVisibility}
                caption={`${persianLanguage.word.transaction.TRANSACTION_TYPE}`}
              />
              <Column
                dataField="amount"
                visible={transactionFieldVisibility?.amountVisibility}
                allowFiltering={true}
                allowHeaderFiltering={false}
                filterOperations={DG_FILTER_EQUALS_TO_OPERATION}
                dataType="number"
                calculateCellValue={persianAmount}
                caption={`${persianLanguage.word.transaction.TRANSACTION_AMOUNT} `}
              />
              <Column
                dataField="quantityDefinitionUnit"
                dataType="string"
                allowFiltering={false}
                allowHeaderFiltering={true}
                headerFilter={{
                  allowSearch: false, // adds a search box in the filter menu
                  dataSource: DG_HEADER_FILTER_QD_UNIT_DATA_SOURCE,
                }}
                filterOperations={filterOperations}
                visible={transactionFieldVisibility?.quantityDefinitionUnitVisibility}
                caption={persianLanguage.word.quantityDefinition.UNIT}
              />
              <Column
                dataField="priceQuantityDefinitionTitle"
                dataType="string"
                allowFiltering={true}
                allowHeaderFiltering={true}
                headerFilter={{
                  allowSearch: true, // adds a search box in the filter menu
                  dataSource: qds,
                }}
                filterOperations={filterOperations}
                visible={transactionFieldVisibility?.priceQuantityDefinitionTitleVisibility}
                caption={persianLanguage.word.quantityDefinition.TITLE}
              />
              <Column
                dataField="unitPrice"
                visible={transactionFieldVisibility?.unitPriceVisibility}
                allowFiltering={true}
                allowHeaderFiltering={false}
                filterOperations={DG_FILTER_EQUALS_TO_OPERATION}
                calculateCellValue={persianUnitPrice}
                dataType="string"
                caption={`${persianLanguage.word.general.UNIT_PRICE}`}
                />
                <Column
                dataField="fullName"
                allowFiltering={true}
                allowHeaderFiltering={false}
                filterOperations={filterOperations}
                dataType="string"
                visible={transactionFieldVisibility?.fullNameVisibility}
                caption={persianLanguage.word.user.USER}
                />
                <Column
                  dataField="createdBy"
                  allowFiltering={true}
                  allowHeaderFiltering={false}
                  dataType="string"
                  filterOperations={DATAGRID_ALLOWED_FILTER_OPERATIONS}
                  visible={transactionFieldVisibility?.createdByVisibility}
                  caption={persianLanguage.word.user.SHOP}
                />
                <Column
                visible={false}
                cellRender={cellRender}
                caption={persianLanguage.word.transaction.REMAINING_DEADLINE_TIME}
                />
                <Column
                visible={transactionFieldVisibility?.durationTimeVisibility}
                dataField="durationTime"
                dataType="string"
                filterOperations={filterOperations}
                allowHeaderFiltering={false}
                allowFiltering={true}
                caption={persianLanguage.word.transaction.DURATION_TIME}
                />
                <Column
                visible={false}
                dataField="shamsiExpiration"
                allowFiltering={false}
                allowHeaderFiltering={false}
                filterOperations={filterOperations}
                dataType="string"
                caption={persianLanguage.word.transaction.EXPIRATION}
                />
                <Column
                width={80}
                dataField="orderTypeLabel"
                dataType="string"
                allowFiltering={true}
                allowHeaderFiltering={false}
                headerFilter={{
                  allowSearch: false, // adds a search box in the filter menu
                  dataSource: DG_HEADER_FILTER_TRANSACTION_ORDER_TYPE_DATA_SOURCE,
                }}
                filterOperations={filterOperations}
                visible={transactionFieldVisibility?.orderTypeLabelVisibility}
                caption={`${persianLanguage.word.transaction.ORDER_TYPE}`}
                />
                <Column
                dataField="totalPrice"
                allowFiltering={true}
                allowHeaderFiltering={false}
                filterOperations={filterOperations}
                calculateCellValue={persianTotalPrice}
                dataType="number"
                visible={transactionFieldVisibility?.totalPriceVisibility}
                caption={persianLanguage.word.general.TOTAL_PRICE}
                />
                <Column
                dataField="description"
                dataType="string"
                visible={transactionFieldVisibility?.descriptionVisibility}
                allowFiltering={false}
                allowHeaderFiltering={false}
                filterOperations={filterOperations}
                caption={persianLanguage.word.general.DESCRIPTIONS}
                />
                <Column
                dataField="userMarkupValue"
                dataType="string"
                calculateCellValue={persianUserMarkupValue}
                visible={false}
                allowFiltering={false}
                allowHeaderFiltering={false}
                filterOperations={filterOperations}
                caption={`${persianLanguage.word.general.AMOUNT} ${persianLanguage.word.general.CHANGE} ${persianLanguage.word.price.PRICE} ${persianLanguage.word.user.USER}`}
                />
                <Column
                dataField="userMarkupChangeTypeTitle"
                dataType="string"
                visible={false}
                allowFiltering={false}
                allowHeaderFiltering={false}
                filterOperations={filterOperations}
                caption={`${persianLanguage.word.general.TYPE} ${persianLanguage.word.general.CHANGE} ${persianLanguage.word.price.PRICE} ${persianLanguage.word.user.USER}`}
                />
                <Column
                dataField="sourceMarkupValue"
                dataType="string"
                calculateCellValue={persianSourceMarkupValue}
                visible={false}
                allowFiltering={false}
                allowHeaderFiltering={false}
                filterOperations={filterOperations}
                caption={`${persianLanguage.word.general.AMOUNT} ${persianLanguage.word.general.CHANGE} ${persianLanguage.word.price.PRICE} ${persianLanguage.word.general.SOURCE}`}
                />
                <Column
                dataField="sourceMarkupChangeTypeTitle"
                dataType="string"
                visible={false}
                allowFiltering={false}
                allowHeaderFiltering={false}
                filterOperations={filterOperations}
                caption={`${persianLanguage.word.general.TYPE} ${persianLanguage.word.general.CHANGE} ${persianLanguage.word.price.PRICE} ${persianLanguage.word.general.SOURCE}`}
                />
              <Column
                dataField="externalTransactionCode"
                dataType="string"
                visible={false}
                allowFiltering={false}
                allowHeaderFiltering={false}
                filterOperations={filterOperations}
              />
                <Column
                dataField="isApprovedChangedBy"
                allowFiltering={true}
                allowHeaderFiltering={false}
                visible={transactionFieldVisibility?.isApprovedChangedByVisibility}
                dataType="string"
                caption={persianLanguage.word.transaction.IS_APPROVED_CHANGED_BY}
                />
                <Column
                dataField="isApprovedTitle"
                dataType="string"
                cellRender={renderIsApprovedTitleCell}
                minWidth={200}
                allowFiltering={true}
                caption={persianLanguage.word.transaction.APPROVED_OR_DISAPPROVED}
                />
            </DataGrid>
          </div>

            <TransactionExpirationDuration />
        </Fragment>
      );
}